import { Component, SimpleChanges } from '@angular/core';
import { RouterLink } from '@angular/router';

import { RtAnalyticsModule, TrackDirective } from '@recruitee/analytics';
import type { TOfferKind } from '@recruitee/offers-types';
import { OfferKind, OfferStatus } from '@recruitee/offers-types';
import { getJobRouterLink } from '@recruitee/offers-util';
import { OfferStatusIndicatorComponent } from '@recruitee/user-interface';

/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
 @angular-eslint/no-inputs-metadata-property,
*/

@Component({
  standalone: true,
  imports: [OfferStatusIndicatorComponent, RtAnalyticsModule, RouterLink, TrackDirective],
  template: `
    @if (offer.kind !== OfferKind.TalentPool) {
      <rt-offer-status-indicator [offerStatus]="offer" margin-right-small-x />
    }
    <a
      [routerLink]="offerLink"
      [rtcAnalyticsTrack]="'[Jobs] Job click'"
      [rtcAnalyticsTrackData]="{ status: offer.status }"
      (click)="$event.stopImmediatePropagation()"
    >
      <span>{{ offer.title }}</span>
    </a>
  `,
  styleUrls: ['./offer-title-cell.component.less'],
  host: {
    '[class]': '"title"',
  },
  inputs: OfferTitleCellComponent.NgInputs,
})
export class OfferTitleCellComponent {
  public static NgInputs = ['offer' as const];

  public offer: { kind: TOfferKind; status: OfferStatus; title: string; slug: string };

  protected readonly OfferKind = OfferKind;
  protected offerLink: string[];

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.offer) {
      const isTalentPool = this.offer.kind === OfferKind.TalentPool;
      this.offerLink = isTalentPool
        ? ['/offers', this.offer.slug, 'filters']
        : getJobRouterLink(this.offer);
    }
  }
}
